import { RadioGroup, Text } from 'uikit';

import cn from 'classnames';

import Styles from './actSourceSelect.module.css';

interface IActSourceSelect {
    value: (typeof radioItems)[0] | undefined;
    onChange: ({ value }: { value: (typeof radioItems)[0] }) => void;
    className?: string;
}

export const radioItems = [
    {
        label: 'Считать итоги Акта из файла',
        hasTotalsFromXml: true,
    },
    {
        label: 'Рассчитать итоги Акта в Системе',
        hasTotalsFromXml: false,
    },
];

export const ActSourceSelect = ({ className, value, onChange }: IActSourceSelect) => (
    <div className={cn(className, Styles.container)}>
        <Text size="s" view="secondary" className={Styles.text}>
            Способ добавления
        </Text>

        <RadioGroup onChange={onChange} items={radioItems} value={value} size="s" />
    </div>
);

ActSourceSelect.displayName = 'ActSourceSelect';
